import { render, staticRenderFns } from "./ActeTypeManagement.vue?vue&type=template&id=9004f0f4&"
import script from "./ActeTypeManagement.vue?vue&type=script&lang=js&"
export * from "./ActeTypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports